import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../components/AuthProvider";
import rolesApi from "../services/roles";

export const findArrays = (
  obj: string[],
  letter: string
): { filteredArrays: string[] } => {
  const filteredArrays = obj
    .filter((elem) => elem.includes(letter))
    .filter((array) => array.length > 0);
  return { filteredArrays };
};

export function usePermission(module: string, permission?: string) {
  const user = useAuth();

  if (!user?.isLoading) {
    const userPermissions = user?.currentUserRole?.permissions!;

    const hasAccess = userPermissions?.some(
      (userPermission) =>
        userPermission.startsWith(module) &&
        (permission ? userPermission.endsWith(permission) : true)
    );

    return hasAccess ? true : false;
  }
}

// this is used to hide/show a module item in the sidebar
// export function useVisibleSideMenu() {
//   const user = useAuth();
//   const currentRole = user?.currentUserRole?.permissions!;
//   if (!user) return []; // no access

//   const isSuperAdmin =
//     user.authUser?.roleId === 'ROLE::81a4a958-2a28-4a77-ab3c-6e4622793baf';

//   const visibleMenu = menu
//     .filter((m) => {
//       const permissionKey = moduleIconRouteMap[m.label as Module];
//       const filteredArray = findArrays(currentRole, 'VIEW').filteredArrays;
//       return filteredArray;
//     })
//     .map((i) =>
//       i.label === 'User Management' && i.subItems
//         ? !isSuperAdmin
//           ? { ...i, subItems: [i.subItems[1]] }
//           : i
//         : i
//     );

//   return visibleMenu;
// }

export const useCurrentUserRole = () => {
  const auth = useAuth();
  const id = auth?.authUser?.roleId!;
  return useQuery([`currentUser-${id}`, id], () => rolesApi.getRoleById(id!));
};
